export class Language {
  code: string;
  name: string;
  identifier: LanguageIdentifier;
  constructor( identifier: LanguageIdentifier, code: string, name: string ) {
    this.code = code;
    this.name = name;
    this.identifier = identifier;
  }
  getShortCode(): string {
    return this.code.split('-')[0];
  }
}

export const Languages = {
  SWEDISH: new Language('SWEDISH', 'sv-se', 'Svenska'),
  DANISH: new Language('DANISH', 'da-dk', 'Dansk'),
  ENGLISH : new Language('ENGLISH', 'en-gb', 'English')
};

export type LanguageIdentifier = 'SWEDISH' | 'DANISH' | 'ENGLISH';
